import { useMountEffect } from "primereact/hooks";

import { useCooperatives } from "@/service/namek/cooperatives/useCooperatives";

export const useLoadingCooperatives = () => {
  const { isLoading, refetch } = useCooperatives();

  useMountEffect(() => {
    refetch();
  });

  return {
    isLoading,
  };
};
